var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_Hierarchy",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 68,
    width: 20,
    height: 14,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 14,
    width: 20,
    height: 14,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 68,
    width: 20,
    height: 14,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 68,
    width: 20,
    height: 14,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 46 50 32 46 32 46 46 16 46 16 64 20 64 20 50 46 50 46 64 50 64 50 50 76 50 76 64 80 64 80 46Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProject);
export default __webpack_public_path__ + "static/media/createProject.dd8a5128fee03a936a7ad301d61dbdff.svg";
export { ForwardRef as ReactComponent };